import { render, staticRenderFns } from "./Productinfo.vue?vue&type=template&id=3f939893&"
import script from "./Productinfo.vue?vue&type=script&lang=js&"
export * from "./Productinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports